import React, { useState } from "react";
import "../styles/contactform.css";
import NavigationBar from "../components/NavigationBar";
import Faqs from "../components/Faqs";
import Footer from "../components/Footer";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import API_URL from "../config/api";

const ContactForm = () => {

    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [subject, setSubject] = useState("");
    const [message, setMessage] = useState("");
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (event) => {

        event.preventDefault();

        setLoading(true);

        try {

            const response = await fetch(`${API_URL}/contact/send_email.php`,
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify({
                        name,
                        email,
                        subject,
                        message
                    })
                }
            );

            const data = await response.json();

            if (data.success) {

                toast.success("Email sent successfully!");

                setName("");
                setEmail("");
                setSubject("");
                setMessage("");

                document.getElementById("conform").reset();

            } else {

                toast.error(data.message);

            }

        } catch (error) {

            console.error(error);

            toast.error("Unable to connect to the server.");

        } finally {

            setLoading(false);

        }

    };

    return (
        <>
            <NavigationBar />

            <section className="contact-form">

                <h1 className="heading">Contact Us</h1>

                <p className="para">
                    Thank you for visiting our website! We value your feedback and inquiries.
                    Please feel free to get in touch with us using the contact information provided below.
                </p>

                <div className="contactForm">

                    <form id="conform" onSubmit={handleSubmit}>

                        <h1 className="sub-heading">Need Support!</h1>

                        <p className="para para2">
                            Contact us for assistance or send us your concerns.
                        </p>

                        <input
                            type="text"
                            className="input"
                            placeholder="Your Name"
                            required
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                        />

                        <input
                            type="email"
                            className="input"
                            placeholder="Your Email"
                            required
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                        />

                        <input
                            type="text"
                            className="input"
                            placeholder="Subject"
                            required
                            value={subject}
                            onChange={(e) => setSubject(e.target.value)}
                        />

                        <textarea
                            className="input"
                            cols="30"
                            rows="5"
                            placeholder="Your Message..."
                            required
                            value={message}
                            onChange={(e) => setMessage(e.target.value)}
                        ></textarea>

                        <input
                            type="submit"
                            className="input submit"
                            value={loading ? "Sending..." : "Send Message"}
                            disabled={loading}
                        />

                    </form>

                    <div className="map-container">

                        <div className="mapBg"></div>

                        <div className="map">

                            <iframe
                                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3864.2375786801704!2d121.44594287561249!3d14.41346348162992!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3397f02b40f56581%3A0x4ef849bbf26fa3dd!2sLaguna%20State%20Polytechnic%20University%20-%20Siniloan%20(Host)%20Campus!5e0!3m2!1sen!2sph!4v1710083470519!5m2!1sen!2sph"
                                width="600"
                                height="450"
                                style={{ border: 0 }}
                                allowFullScreen=""
                                loading="lazy"
                                referrerPolicy="no-referrer-when-downgrade"
                                title="LSPU Map"
                            ></iframe>

                        </div>

                    </div>

                </div>

                <div className="contactMethod">

                    <div className="method">

                        <i className="fa-solid fa-location-dot contactIcon"></i>

                        <article className="text">

                            <h1 className="sub-heading">Location</h1>

                            <p className="para">
                                CC7X+9CJ, L. de Leon Street,
                                Siniloan, Laguna 4019
                            </p>

                        </article>

                    </div>

                    <div className="method">

                        <i className="fa-solid fa-envelope contactIcon"></i>

                        <article className="text">

                            <h1 className="sub-heading">Email</h1>

                            <p className="para">
                                arboreatrix001@gmail.com
                            </p>

                        </article>

                    </div>

                    <div className="method">

                        <i className="fa-solid fa-phone contactIcon"></i>

                        <article className="text">

                            <h1 className="sub-heading">Phone</h1>

                            <p className="para">
                                +63 998-987-2119
                            </p>

                        </article>

                    </div>

                </div>

            </section>

            <div className="faqss">
                <Faqs />
            </div>

            <footer>
                <Footer />
            </footer>

            <ToastContainer
                position="top-center"
                autoClose={2000}
            />

        </>
    );

};

export default ContactForm;